import { IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonPage, IonToolbar } from "@ionic/react"
import { TopUpPromotionDescription } from "../../types/types"
import AppHeader from "../../components/AppHeader/AppHeader"
import { ReactMarkdown } from "react-markdown/lib/react-markdown"
import remarkGfm from "remark-gfm";
import { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";
import { closeOutline } from "ionicons/icons";

interface InfoComponentProps extends PropsWithChildren {
    info: TopUpPromotionDescription[],
    closeAction:Function
}

const ToUpPromotionInfoPage: React.FC<InfoComponentProps> = ({info,closeAction}) => {

    const { t, i18n } = useTranslation();
    // const nav = document.querySelector("ion-nav");

    return (
        <IonPage>
            <IonHeader className="ion-no-border">

            <IonToolbar>

                <IonButtons slot="start">
                    <IonButton onClick={() => { closeAction() }} color={'primary'}>
                        <IonIcon slot="icon-only" icon={closeOutline}/>
                    </IonButton>

                </IonButtons>
                </IonToolbar>

              

                <AppHeader
                    title={t('topups_products.page.PROMOTION-HEADER') as string}
                    goBack={false}
                >

                </AppHeader>

            </IonHeader>
            <IonContent className="ion-padding">
                <ReactMarkdown
                    className="reactMarkdown"
                    children={info[0].terms_and_conditions}
                    remarkPlugins={[remarkGfm]}
                />
            </IonContent>
        </IonPage>

    )
}

export default ToUpPromotionInfoPage